  import axios from 'axios';
  import { toast } from 'sonner';

  // Create a base API client
  const api = axios.create({
    baseURL: '/api', // Assuming the backend API is served from the same domain
    withCredentials: true, // Include cookies in requests (for session-based auth)
    headers: {
      'Content-Type': 'application/json',
    },
  });

  // Request interceptor to add auth token to every request
  api.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('authToken');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor to handle errors globally
  api.interceptors.response.use(
    (response) => response,
    (error) => {
      const { response } = error;
      
      // Handle authentication errors
      if (response && response.status === 401) {
        localStorage.removeItem('authToken');
        if (window.location.pathname !== '/login') {
          toast.error('Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.');
          setTimeout(() => {
            window.location.href = '/login';
          }, 2000);
        }
      }
      
      // Handle server errors
      else if (response && response.status >= 500) {
        toast.error('Ein Serverfehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
      }
      
      // Handle API errors with messages
      else if (response && response.data && response.data.message) {
        toast.error(response.data.message);
      }
      
      // Handle network errors
      else if (!response) {
        toast.error('Netzwerkfehler: Keine Verbindung zum Server möglich.');
      }
      
      return Promise.reject(error);
    }
  );

  export default api;
